import FooterNavbar from "../../../footernavbar/FooterNavbar";

const Brands = () => {
  return (
    <>
      <div className=" display-max">
        <FooterNavbar />
        <div className="mt-3 py-3">
          <div className="row">
            <div className="container">
              <div className="col-lg-12 justify-content-center text-center ">
                <h1 className=" text-black source-serif-4 text-normal mt-2">
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-l text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                  The New Standard in E-Commerce
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-r text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                </h1>
              </div>
            </div>
          </div>
          <section className="py-1">
            <div className="row">
              <div className="container">
                <div className="col-lg-12 justify-content-center text-center ">
                  <span className="badge rounded-pill badge-warning text-capitalize text-white badge-md text-lg mb-2">
                    Overview
                  </span>
                  <h5 className=" text-black source-serif-4 text-normal mt-2">
                    <sup>
                      <i
                        className="ri-double-quotes-l text-dark text-lg"
                        aria-hidden="true"
                      ></i>{" "}
                    </sup>
                    Salar, an innovative brand from Sworld Solutions Private
                    Limited, is swiftly emerging as a trailblazer in the
                    e-commerce industry. <br /> With a wide-ranging selection of
                    products and a commitment to excellence, Salar aims to
                    provide an unparalleled shopping experience for customers
                    and a supportive platform for sellers.
                    <sup>
                      <i
                        className="ri-double-quotes-r text-dark text-lg"
                        aria-hidden="true"
                      ></i>{" "}
                    </sup>
                  </h5>
                </div>
              </div>
            </div>
          </section>
          <div className="w-35 mx-auto mt-0">
            <div>
              <img
                src="../../assets/img/salarlogo.png"
                alt="img-blur-shadow-blog-2"
                className="img-full "
                loading="lazy"
              />
            </div>
          </div>
        </div>
        <section className="py-0">
          <div className="row">
            <div className="container">
              <div className="col-lg-12 justify-content-center text-center ">
                <h3 className=" text-black source-serif-4 text-normal mt-2">
                  <sup>
                    {" "}
                    <i
                      className="bi bi-quote text-dark"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                  Extensive Product Categories
                  <sup>
                    {" "}
                    <i
                      className="bi bi-quote text-dark"
                      aria-hidden="true"
                    ></i>
                  </sup>
                </h3>
                <h5 className=" text-black source-serif-4 text-normal mt-2">
                  Salar boasts a diverse array of products across numerous
                  categories, ensuring a comprehensive shopping experience:
                </h5>
              </div>
            </div>
          </div>
        </section>
        <div className="d-flex container justify-content-lg-start overflow-scroll justify-content-center gap-3 py-4 px-4">
          <div>
            <div className="d-block blur-shadow-image">
              <div
                className="page-header border-radius-xl category-images"
                style={{
                  backgroundImage:
                    "url('../../assets/img/footer/fashion-brand.jpg')",
                }}
              >
                <div className="card-body pt-14 px-3">
                  <h5 className="text-white">
                    Fashion is the armor to survive the reality of everyday
                    life.
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="d-block blur-shadow-image">
              <div
                className="page-header border-radius-xl category-images"
                style={{
                  backgroundImage:
                    "url('../../assets/img/footer/groceries-brand.jpg')",
                }}
              >
                <div className="card-body pt-14 px-3">
                  <h5 className="text-white">
                    Groceries are the building blocks of delicious memories.
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="d-block blur-shadow-image">
              <div
                className="page-header border-radius-xl category-images"
                style={{
                  backgroundImage:
                    "url('../../assets/img/footer/furniture-brand.jpg')",
                }}
              >
                <div className="card-body pt-14 px-3">
                  <h5 className="text-white">
                    where comfort meets character in every corner of the home.
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="d-block blur-shadow-image">
              <div
                className="page-header border-radius-xl category-images"
                style={{
                  backgroundImage:
                    "url('../../assets/img/footer/kitechen-brand.jpg')",
                }}
              >
                <div className="card-body pt-14 px-3">
                  <h5 className="text-white">
                    Make cooking effortless, turning ingredients into
                    masterpieces.
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="d-block blur-shadow-image">
              <div
                className="page-header border-radius-xl category-images"
                style={{
                  backgroundImage:
                    "url('../../assets/img/footer/beauty-brand.jpg')",
                }}
              >
                <div className="card-body pt-14 px-3">
                  <h5 className="text-white">
                    Enhance natural charm, boosting confidence and radiant glow.
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="d-block blur-shadow-image">
              <div
                className="page-header border-radius-xl category-images"
                style={{
                  backgroundImage:
                    "url('../../assets/img/footer/electronics-brand.jpg')",
                }}
              >
                <div className="card-body pt-14 px-3">
                  <h5 className="text-white">
                    Simplify life, connecting us to endless possibilities daily.
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="d-block blur-shadow-image">
              <div
                className="page-header border-radius-xl category-images"
                style={{
                  backgroundImage:
                    "url('../../assets/img/footer/books-brand.jpg')",
                }}
              >
                <div className="card-body pt-14 px-3">
                  <h5 className="text-white">
                    {" "}
                    Open minds, inspire creativity, and transport readers to new
                    worlds.
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="d-block blur-shadow-image">
              <div
                className="page-header border-radius-xl category-images"
                style={{
                  backgroundImage:
                    "url('../../assets/img/footer/automotive-brand.jpg')",
                }}
              >
                <div className="card-body pt-14 px-3">
                  <h5 className="text-white">
                    Innovation drives progress, fueling adventures and shaping
                    our future.
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="d-block blur-shadow-image">
              <div
                className="page-header border-radius-xl category-images"
                style={{
                  backgroundImage:
                    "url('../../assets/img/footer/footwear-brand.jpg')",
                }}
              >
                <div className="card-body pt-14 px-3">
                  <h5 className="text-white">
                    Combines style and comfort, supporting every step with
                    confidence.
                  </h5>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="d-block blur-shadow-image">
              <div
                className="page-header border-radius-xl category-images"
                style={{
                  backgroundImage:
                    "url('../../assets/img/footer/jewellery-brand.jpg')",
                }}
              >
                <div className="card-body pt-14 px-3">
                  <h5 className="text-white">
                    Adds sparkle, expressing individuality and enhancing
                    timeless elegance.
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container w-80">
          <section className="py-5">
            <div className="container">
              <div className="row">
                <div className="col-lg-6 col-10 d-flex justify-content-center flex-column  text-lg-start text-center">
                  <div className="mb-3">
                    <h4 className="mb-2 text-black fw-bold">Clothing</h4>
                    <p className="mb-2 fs-5  text-black">
                      Explore the latest trends and timeless styles for men,
                      women, and kids, catering to every fashion need and
                      preference.
                    </p>
                  </div>
                  <div>
                    <h4 className="mb-2 text-black fw-bold ">Grocery & Food</h4>
                    <p className="mb-2 fs-5 text-black">
                      From daily essentials to gourmet delights, Salar offers a
                      vast selection of grocery and food items to meet all
                      culinary needs.
                    </p>
                  </div>
                  <div>
                    <h4 className="mb-2 text-black fw-bold ">Furniture</h4>
                    <p className="mb-2 fs-5 text-black">
                      Enhance your living space with Salar’s range of stylish
                      and functional furniture, suitable for every room and
                      aesthetic.
                    </p>
                  </div>
                  <div>
                    <h4 className="mb-2 text-black fw-bold ">Home & Kitchen</h4>
                    <p className="mb-2 fs-5  text-black">
                      Discover a variety of innovative gadgets and essential
                      household items to elevate your home and kitchen.
                    </p>
                  </div>
                  <div>
                    <h4 className="mb-2 text-black fw-bold ">
                      Beauty & Personal Care
                    </h4>
                    <p className="mb-2 fs-5 text-black">
                      Indulge in a wide array of beauty and personal care
                      products, including skincare, haircare, and grooming
                      essentials.
                    </p>
                  </div>
                  <div>
                    <h4 className="mb-2 text-black fw-bold ">
                      Digital Products
                    </h4>
                    <p className="mb-2 fs-5 text-black">
                      Stay updated with the latest in digital products,
                      including software, e-books, and online services.
                    </p>
                  </div>
                  <div>
                    <h4 className="mb-2 text-black fw-bold">Books</h4>
                    <p className="mb-2 fs-5 text-black">
                      Dive into a world of knowledge and entertainment with a
                      diverse collection of books across various genres.
                    </p>
                  </div>
                </div>
                <div className="col-lg-1"></div>
                <div className="col-lg-5 col-6 mx-lg-0 mx-auto px-lg-0 px-md-0 my-auto">
                  <img
                    className="w-100 border-radius-lg shadow"
                    src="../../assets/img/footer/brand-image-2.jpg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </section>
          <section className="py-5">
            <div className="container">
              <div className="row">
                <div className="col-lg-5 col-6 mx-lg-0 mx-auto px-lg-0 px-md-0 my-auto">
                  <img
                    className="w-100 border-radius-lg "
                    src="../../assets/img/footer/Brand-image-1.jpg"
                    alt=""
                  />
                </div>
                <div className="col-lg-1"></div>
                <div className="col-lg-6 col-10 d-flex justify-content-center flex-column  text-lg-start text-center">
                  <div>
                    <h4 className="mb-2 text-black fw-bold">Electronics</h4>
                    <p className="mb-2 fs-5  text-black">
                      Keep pace with the latest technology, featuring gadgets,
                      home appliances, and electronics accessories.
                    </p>
                  </div>
                  <div>
                    <h4 className="mb-2 text-black fw-bold">
                      Automobiles & Industrial Supplies
                    </h4>
                    <p className="mb-2 fs-5  text-black">
                      Find a variety of automotive parts and industrial supplies
                      designed for professionals and DIY enthusiasts alike.
                    </p>
                  </div>
                  <div>
                    <h4 className="mb-2 text-black fw-bold">Pet Food</h4>
                    <p className="mb-2 fs-5  text-black">
                      Ensure your pets receive the best nutrition with Salar’s
                      selection of high-quality pet food products.
                    </p>
                  </div>
                  <div>
                    <h4 className="mb-2 text-black fw-bold">Footwear</h4>
                    <p className="mb-2 fs-5  text-black">
                      Step out in style with Salar’s diverse range of footwear,
                      including casual, athletic, formal, and seasonal options.
                    </p>
                  </div>
                  <div>
                    <h4 className="mb-2 text-black fw-bold">Traveling Bags</h4>
                    <p className="mb-2 fs-5 text-black">
                      Whether for business or leisure, discover the perfect
                      traveling bags that combine durability with modern design.
                    </p>
                  </div>
                  <div>
                    <h4 className="mb-2 text-black fw-bold">
                      Sports, Fitness & Outdoor
                    </h4>
                    <p className="mb-2 fs-5  text-black">
                      Equip yourself for an active lifestyle with a range of
                      sports, fitness, and outdoor products.
                    </p>
                  </div>
                  <div>
                    <h4 className="mb-2 text-black fw-bold">Jewelry</h4>
                    <p className="mb-2 fs-5  text-black">
                      Adorn yourself with exquisite jewelry pieces that add
                      elegance to any outfit. Fashion: Stay fashionable with a
                      wide variety of accessories and apparel that keep you
                      looking your best.
                    </p>
                  </div>
                  <div className="text-align-start text-start">
                    <h4 className="mb-2 text-black fw-bold">
                      Home Improvement
                    </h4>
                    <p className="mb-2 fs-5 text-black">
                      Find everything you need for DIY projects and home
                      improvement, from tools to materials.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <div className="row py-5">
            <div className="container">
              <div className="col-lg-12 justify-content-center text-center ">
                <h2 className=" text-black source-serif-4 text-normal mt-2">
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-l text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                  Seller-Centric Approach
                  <sup>
                    {" "}
                    <i
                      className="ri-double-quotes-r text-dark text-5xl"
                      aria-hidden="true"
                    ></i>{" "}
                  </sup>
                </h2>
                <h5 className=" text-black source-serif-4 text-normal mt-2">
                  Salar sets itself apart with a unique focus on supporting
                  sellers, offering several key benefits:
                </h5>
              </div>
            </div>
          </div>
        </div>
        <section className="py-sm-0 w-80 mx-auto">
          <div className="container">
            <div className="row d-flex justify-content-center align-items-center">
              <div className="col-lg-8">
                <div className="row mt-3">
                  <div className="col-sm-6 col-lg-4 mt-lg-0 mt-4">
                    <h5>No Subscription Fees</h5>
                    <p className="text-sm font-weight-normal text-black">
                      Sellers can join the platform without any initial costs,
                      making it accessible to businesses of all sizes.
                    </p>
                  </div>
                  <div className="col-sm-6 col-lg-4 mt-lg-0 mt-4">
                    <h5>Lowest Commission Rates</h5>
                    <p className="text-sm font-weight-normal text-black">
                      Enjoy some of the lowest commission rates in the industry,
                      allowing sellers to maximize their profits.
                    </p>
                  </div>
                  <div className="col-sm-6 col-lg-4 mt-lg-0 mt-4">
                    <h5>Global Selling Opportunities</h5>
                    <p className="text-sm font-weight-normal text-black">
                      Expand your reach with access to international markets and
                      grow your business globally.
                    </p>
                  </div>
                  <div className="col-sm-6 col-lg-4 mt-lg-5 mt-4">
                    <h5>Fast Payments</h5>
                    <p className="text-sm font-weight-normal text-black">
                      Experience efficient payment processing, ensuring quick
                      and reliable access to earnings.
                    </p>
                  </div>
                  <div className="col-sm-6 col-lg-4 mt-lg-5 mt-5">
                    <h5>Shipping Services</h5>
                    <p className="text-sm font-weight-normal text-black">
                      {" "}
                      Benefit from comprehensive shipping solutions that
                      simplify logistics and enhance customer satisfaction.
                    </p>
                  </div>
                  <div className="col-sm-6 col-lg-4 mt-lg-5 mt-4">
                    <h5>Product Marketing</h5>
                    <p className="text-sm font-weight-normal">
                      Leverage targeted marketing campaigns to increase product
                      visibility and attract more customers.
                    </p>
                  </div>
                  <div className="col-sm-6 col-lg-4 mt-lg-5 mt-4">
                    <h5>Partner Services</h5>
                    <p className="text-sm font-weight-normal">
                      Access additional support services, including product
                      photography, content creation, and customer service, to
                      help your business thrive.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="w-100 mx-auto mt-0">
                  <div>
                    <img
                      src="../../assets/img/footer/seller-1.png"
                      alt="img-blur-shadow-blog-2"
                      className="img-full "
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="row py-8">
          <div className="container">
            <div className="col-lg-12 justify-content-center text-center ">
              <h2 className=" text-black source-serif-4 text-normal mt-2">
                <sup>
                  {" "}
                  <i
                    className="ri-double-quotes-l text-dark text-5xl"
                    aria-hidden="true"
                  ></i>{" "}
                </sup>
                Customer-Centric Experience
                <sup>
                  {" "}
                  <i
                    className="ri-double-quotes-r text-dark text-5xl"
                    aria-hidden="true"
                  ></i>{" "}
                </sup>
              </h2>
              <h5 className=" text-black source-serif-4 text-normal mt-2">
                Salar is dedicated to providing an exceptional shopping
                experience, focusing on:
              </h5>
            </div>
          </div>
          <section className="py-sm-0 w-80 mx-auto">
            <div className="container">
              <div className="row d-flex justify-content-center align-items-center">
                <div className="col-lg-4">
                  <div className="w-100 mx-auto mt-0">
                    <div>
                      <img
                        src="../../assets/img/footer/user-1.png"
                        alt="img-blur-shadow-blog-2"
                        className="img-full "
                        loading="lazy"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-8">
                  <div className="row mt-3">
                    <div className="col-sm-6 col-lg-12 mt-lg-0 mt-4 mb-4">
                      <h3>User-Friendly Platform </h3>
                      <p className="text-lg font-weight-normal text-black">
                        Navigate easily through an intuitive interface designed
                        for a seamless shopping journey.
                      </p>
                    </div>
                    <div className="col-sm-6 col-lg-12 mt-lg-0 mt-4 mb-4">
                      <h3>Secure Payments</h3>
                      <p className="text-lg font-weight-normal text-black">
                        Enjoy peace of mind with secure payment options that
                        protect your financial information.
                      </p>
                    </div>
                    <div className="col-sm-6 col-lg-10 mt-lg-0 mt-4">
                      <h3>Reliable Customer Service</h3>
                      <p className="text-lg font-weight-normal text-black">
                        Receive prompt and helpful support for any queries or
                        issues. Regular Promotions: Take advantage of frequent
                        discounts and promotions to get the best deals on your
                        favorite products.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="py-5">
            <div className="row">
              <div className="container">
                <div className="col-lg-12 justify-content-center text-center ">
                  <span className="badge rounded-pill badge-warning text-white text-capitalize badge-md text-lg mb-2">
                    Conclusion
                  </span>
                  <h5 className=" text-black source-serif-4 text-normal mt-2">
                    <sup>
                      <i
                        className="ri-double-quotes-l text-dark text-lg"
                        aria-hidden="true"
                      ></i>{" "}
                    </sup>
                    As an emerging brand, Salar is setting new standards in the
                    e-commerce world. With its extensive product range,
                    seller-friendly policies, and customer-centric approach,{" "}
                    <br /> Salar is quickly becoming a leading name in online
                    retail. Whether you're a seller looking for a profitable
                    platform or a shopper seeking quality products and a
                    seamless experience, <br /> Salar is the destination for
                    you. Explore Salar today and be part of the future of
                    e-commerce.
                    <sup>
                      <i
                        className="ri-double-quotes-r text-dark text-lg"
                        aria-hidden="true"
                      ></i>{" "}
                    </sup>
                  </h5>
                </div>
              </div>
            </div>
          </section>
          <div className="w-60 h-50 mx-auto mt-0">
            <div className="d-block blur-shadow-image">
              <img
                src="../../assets/img/footer/brands-image.jpeg"
                alt="img-blur-shadow-blog-2"
                className="img-full "
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Brands;
